
export default {
  data: () => ({
    waypoint: {},
    intersectionOptions: {
      root: null,
      rootMargin: '0px',
      threshold: [0] // [0.25, 0.75] if you want a 25% offset!
    }
  }),
  methods: {
    onWaypointEnter({el, going, direction}){
      
      if(going == 'in' && direction){

        let section = el.dataset.section;
        // console.log('');
        // console.log();
        // console.log(section + ' is ' + going + (going ? '' : ' of the') + ' viewport. direction: ' + direction);
        // console.log('');
        this.$emit('waypoint-enter', section);
      }
    }
  },
  mounted(){
    const vm = this;
    // console.log(document.querySelector('.agent-website__main'));

  }
};